var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi_5129648",
    enableBackground: "new 0 0 513.193 513.193",
    height: 20,
    viewBox: "0 0 513.193 513.193",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m47.623 386.186c-26.083 0-47.133 21.102-47.133 47.134v64.267c.738 19.881 29.269 19.866 30 0v-17.134h34.267v17.134c.738 19.881 29.269 19.866 30 0v-64.267c0-26.085-21.106-47.134-47.134-47.134zm17.134 64.267h-34.267v-17.133c.829-22.718 33.452-22.688 34.267 0z",
    fill: "#8BA4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.767 482.587h-17.134v-81.4c-.738-19.881-29.269-19.866-30 0v96.4c0 8.284 6.716 15 15 15h32.134c19.88-.738 19.865-29.27 0-30z",
    fill: "#8BA4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.1 482.587h-17.134v-81.4c-.738-19.881-29.269-19.866-30 0v96.4c0 8.284 6.716 15 15 15h32.134c19.88-.738 19.865-29.27 0-30z",
    fill: "#8BA4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.809 426.701c151.697-183.714 19.316-422.903-191.316-426.116-173.308-3.104-301.671 179.328-241.405 341.348 2.12 5.99 7.785 9.994 14.14 9.994h69.825c5.223 0 10.07-2.717 12.796-7.173 2.726-4.455 2.937-10.008.559-14.658-55.451-105.186 25.067-236.722 144.084-235.239 135.477-1.11 211.86 161.849 124.484 265.009l-27.359-27.366c-3.896-3.898-9.616-5.344-14.898-3.768-5.281 1.576-9.272 5.922-10.395 11.319l-32.134 154.492c-2.357 12.226 9.181 19.901 17.74 17.741l154.481-32.135c5.396-1.122 9.741-5.114 11.318-10.395s.131-11.001-3.767-14.898z",
    fill: "#8BA4BF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/All.cb3ef4320a0c0bf5385bce7d7c66d0f2.svg";
export { ForwardRef as ReactComponent };